import { AfterViewInit, DestroyRef, Directive, ElementRef, inject, input, NgZone } from '@angular/core';
import { OnChildListMutations } from '@coin/shared/core/util-helpers';
import { combineLatest, Observable } from 'rxjs';
import { filter, startWith, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SimpleTableGroupState } from './group-state.enum';

@Directive({
  selector: '[adminTableGroup]'
})
export class TableGroupDirective implements AfterViewInit {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private destroyRef = inject(DestroyRef);
  private readonly zone = inject(NgZone);

  readonly adminTableGroup = input<Observable<SimpleTableGroupState[]>>(undefined);

  ngAfterViewInit(): void {
    // A row's columns can render after the row itself, so the classes are re-applied whenever its children change.
    // Outside the zone, because the observer of every single row would otherwise trigger a change detection run.
    this.zone.runOutsideAngular(() =>
      combineLatest([this.adminTableGroup(), OnChildListMutations(this.elementRef.nativeElement).pipe(startWith(null))])
        .pipe(
          filter(() => !!this.elementRef),
          tap(() => this.resetClasses())
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(([inactiveColumns]) => {
          inactiveColumns.forEach((state, index) => {
            if (state !== SimpleTableGroupState.Visible) {
              this.elementRef.nativeElement.children.item(index)?.classList.add(state);
            }
          });
        })
    );
  }

  private resetClasses(): void {
    for (let i = 0; i < this.elementRef.nativeElement.children?.length; i++) {
      this.elementRef.nativeElement.children
        .item(i)
        .classList.remove(SimpleTableGroupState.Inactive, SimpleTableGroupState.Hidden);
    }
  }
}
